import "./ManageSessions.scss";
import moment from 'moment-timezone';
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { useEffect, useState } from "react";
import {
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  API_RESPONSE,
  CREATE_SESSIONS_FIELD,
} from "../../Utilities/Constants/Constants";
import { axiosInstance } from "../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../Utilities/Constants/ApiEndpoints";
import { useTranslation } from "react-i18next";
import "moment/locale/ar";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import BookingDialog from "../BookingDialog/BookingDialog";

const CalenderSession = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [dialogOpenStatus, setDialogOpenStatus] = useState(API_RESPONSE.FALSE);
  const [startDate, setStartDate] = useState("");
  const [currentMode, setCurrentMode] = useState("")
  const [editPayload, setEditPayload]: any = useState();
  const [currentViewType, setCurrentViewType] = useState(CREATE_SESSIONS_FIELD.MONTH)
 
  const [myEventsList, setMyEventsList] = useState([]);
  const localizer = momentLocalizer(moment);
  const [roleId, setRoleId] = useState("")
  const { id, role } = useParams();

  useEffect(() => {

  }, []);

  
  useEffect(() => {
    const pathName = window.location?.pathname;
    const payload = {
      record_area: pathName.slice(1)
    }
    axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
    }).catch(() => {
    })
  }, [])
  
 
  const getUserRole = () => {
    const payload = {
      "teach_service_provider":Number(role),
      "id":Number(id)
    }
    setRoleId(roleId);
    onGetSessions(payload)
    
  }

 
  useEffect(() => {
    getUserRole();
    
    moment.locale('en');
    localizer.formats = { ...localizer.formats, };
  }, [t]);

 
  const onSelectEvent = (event: any, e: any) => {
    setCurrentMode(COMMON_CONSTANTS.EDIT)
    setDialogOpenStatus(API_RESPONSE.TRUE);
    setDate(e.start);
    setEditPayload(event);
  };



 
  const timeFormat = (time: any) => {
    return moment(time, COMMON_CONSTANTS.HM_FORMAT).format(COMMON_CONSTANTS.HMA_FORMAT);
  }

 
  const eventPropsRender = (event: any) => {
    return (
      <div className={event.event.free_session === API_RESPONSE.TRUE ? " free-session" : "time-wrapper"}>
        <p className="event-title">{event.title}</p>
        {currentViewType === CREATE_SESSIONS_FIELD.MONTH && <p className="event-time">{timeFormat(event.event.start)}-{timeFormat(event.event.end)}</p>}
      </div>
    )
  }
  const currentTime = moment();
const dubaiTime = currentTime.tz('Asia/Dubai');


  const TimeIndicator = () => {
    
    const dubaiCurrentTime = moment.tz('Asia/Dubai');
    
      const totalMinutesInDay = 24 * 60; 

      
      const topPosition = ((dubaiCurrentTime.hours() * 60 + dubaiCurrentTime.minutes()) / (24 * 60)) * 100;
    return (
      <div
        style={{
          position: 'absolute',
          top: `${topPosition}%`,
          left: 100,
          right: 20,
          height: 1,
          backgroundColor: 'green',
          zIndex: 9999,
        }}
      />
    );
  };


 
  const renderCalendar = () => {
    
    moment.locale('en');
    return (
      <Calendar
        selectable
        localizer={localizer}
        events={myEventsList}
        onDoubleClickEvent={onDoubleClick}
        onView={onSelecting}

        onSelectSlot={(e: any) => {
          if (moment(e.start).format(COMMON_CONSTANTS.YMD_FORMAT) >= moment(new Date()).format(COMMON_CONSTANTS.YMD_FORMAT)) {
            setCurrentMode(COMMON_CONSTANTS.CREATE);
            setDialogOpenStatus(API_RESPONSE.TRUE);
            setDate(e.start);
          } else {
            toast.error("REGISTRATION_ERRORS.SESSION_VALID_DATE");
          }

        } }
        onKeyPressEvent={() => { } }
        showMultiDayTimes={true}
        onSelectEvent={(event: any, e: any) => { onSelectEvent(event, e); } }
        components={{
          event: eventPropsRender,
          
          
          
        }} /> 
      )
  };

 
  const formatEvents = (data: any) => {
    const format = data.map((date: any) => {
      return {
        
        
        start: new Date(date.start),
        end: new Date(date.end),
        title: date.title,
        slot_id: date.session_slot,
        timeslot_id: date.id,
        free_session: date.is_free_session,
        service_session_id: date.service_provider_id,
        teach_service: date.teach_service_provider_id,
      };
    });
    setMyEventsList(format);
  };


 
  const onGetSessions = (payload: any) => {
    axiosInstance
      .post(API_END_POINTS.SESSIONS_LIST, payload)
      .then((response) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          formatEvents(response.data.result.data);
        }
      })
      .catch(()=>{});
  }

  
  
  
    
  

 
  const setDate = (date: any) => {
    setStartDate(moment(date).local().format(COMMON_CONSTANTS.MDY_FORMAT));
  };

  const onDoubleClick = () => {
  };

  const onSelecting = (event: any) => {
    setCurrentViewType(event)
  };

 
  const onCloseDialog = () => {
    setDialogOpenStatus(API_RESPONSE.FALSE);
    setCurrentMode("");
    getUserRole();
  };

  return (
    <div className="calender-session-wrapper">

    {currentMode === "Edit" && 
    <BookingDialog
      openStatus={dialogOpenStatus}
      onCloseDialog = {onCloseDialog}
      currentDate={startDate}
      payload = {editPayload}
      />
      }
      {currentMode === "Create" && toast("SELECT THE SLOTS TO MANUPLATE")}
      <div>
        {renderCalendar()}
      </div>
    </div>
  );
};

export default CalenderSession;
